import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Textarea,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../services/api';
import { user } from '../../../helpers/user';

export function Aprovar({ id, isApproved }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [observacao, setObservacao] = React.useState('');
  console.log(id);

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true
  });
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async () => {
      try {
        await api.post(`/site/v2/crm-controle/aprovar-curriculo-usuario`, {
          id_usuario: id,
          observacao: observacao,
          usuario_aprovacao: user?.nome_usuario
        });
      } catch (error) {
        throw new Error(error);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('curriculos-vendedores');
      onClose();
      setObservacao('');
      toast({
        title: 'Currículo aprovado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true
      });
    }
  });

  async function handleApprove() {
    try {
      await mutateAsync();
    } catch (error) {
      toast({
        title: 'Erro ao aprovar currículo',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
    }
  }

  return (
    <>
      <Button colorScheme="blue" size="sm" onClick={onOpen} disabled={isApproved}>
        {isApproved ? 'Aprovado' : 'Aprovar'}
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Aprovar Currículo
            </AlertDialogHeader>

            <AlertDialogBody>
              Digite uma observação para o candidato:
              <Textarea
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Digite aqui..."
                mt={2}
              />
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="green" ml={3} isLoading={isLoading} onClick={handleApprove}>
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
